import { useAppSelector } from "../../store/hooks/useAppSelector";
import { IRaffle } from "../../store/interfaces/IRaffle";
import { RootState } from "../../store/types/rootState";
import Footer from "../layout/footer";
import { ActiveRaffle } from "./ActiveRaffle";
import { ActiveRaffle2 } from "./ActiveRaffle2";

const ACCOUNTS_WITHOUT_FOOTER = ['oscar-alarcon', 'minas-de-baruta', 'oscar-alarcon-promo'];

export const RaffleTemplate = ({ raffle }: { raffle: IRaffle }) => {
  switch (raffle.templateId) {
    case 'template1':
      return <ActiveRaffle2 activeRaffle={raffle} />;
    default:
      return <ActiveRaffle activeRaffle={raffle} />;
  }
};

export const RaffleFooter = () => {
  const accountId = useAppSelector(({ account }: RootState) => account.id);
  return ACCOUNTS_WITHOUT_FOOTER.includes(accountId) ? null : <Footer />;
};
